export default __webpack_public_path__ + "1276665d9648dd21af8f88d54dff01cd.png";